import React, { useState, useEffect } from 'react'
import Card from 'react-bootstrap/Card';
import { useDropzone } from 'react-dropzone'
import Dropzone from 'react-dropzone';
import { IconInfoCircleFilled, IconFileUpload } from '@tabler/icons-react';
import { MySwal } from '../../../lib/swal'
import axios from '../../../lib/axios'
import errorHandler from '../../../helpers/errorHandler';

const RiwayatTransaksiFormGLComp = (props) => {
    // console.log(props)
    const dns = window.location.hostname
    const [newGL, setnewGL] = useState('')
    const [disabled, setDisabled] = useState(false);
    const [required, setRequired] = useState(false);

    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }

    const handleDrop = (file) => {
        setnewGL(file[0])
    }

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ handleDrop }) // eslint-disable-line

    const handleUpdate = async () => {
        try {
            setDisabled(true)
            if (
                newGL.name === undefined
            ) {
                setRequired(true)
                MySwal.fire({
                    position: 'top-end',
                    icon: 'warning',
                    title: '<h2>Oops, Gagal</h2>',
                    html: '<h5>Belum ada file yang di upload!</h5>',
                    showConfirmButton: false,
                    timer: 3000
                })
                setDisabled(false)
            } else {
                const formData = new FormData()
                formData.append('guaranteeLetter', newGL)

                const { data } = await axios({
                    url: `users/transactions/${props.items.id}/guaranteeLetter`,
                    method: 'POST',
                    data: formData,
                    headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` },
                })

                if (data.code === "201") {
                    setRequired(false)
                    MySwal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: '<h2>Sukses</h2>',
                        html: '<h5>Berhasil mengupload GL!</h5>',
                        showConfirmButton: false,
                        timer: 3000
                    })
                    setTimeout(() => {
                        props.close()
                        setDisabled(false)
                    }, 3000);
                }
            }
        } catch (err) {
            setRequired(true)
            errorHandler({ err: err?.response?.data || err })
            setDisabled(false)
            console.log(err)
        }
    }

    const handleDownloadGl = (glFile) => {
        if (dns === "localhost") {
            window.open(`http://localhost:4000/api/assets/${glFile}`, '_blank');
        } else if (dns === "192.168.100.23") {
            window.open(`http://192.168.100.23:3005/api/assets/${glFile}`, '_blank');
        } else if (dns === "or-v3.prasmul-eli.co") {
            window.open(`https://or-v3.prasmul-eli.co/api/assets/${glFile}`, '_blank');
        } else {
            window.open(`https://registration.prasmul-eli.co/api/assets/${glFile}`, '_blank');
        }
    }

    const handleShowGl = () => {
        if (dns === "localhost") {
            window.open('http://localhost:4000/api/assets/gl_form.docx', '_blank');
        } else if (dns === "192.168.100.23") {
            window.open('http://192.168.100.23:3005/api/assets/gl_form.docx', '_blank');
        } else if (dns === "or-v3.prasmul-eli.co") {
            window.open(`https://or-v3.prasmul-eli.co/api/assets/gl_form.docx`, '_blank');
        } else {
            window.open(`https://registration.prasmul-eli.co/api/assets/gl_form.docx`, '_blank');
        }
    }

    // console.log(newGL)

    return (
        <div className='row'>
            <div className='col-lg-12' style={{ marginTop: '2%' }}>
                <Card
                    bg='warning'
                    key='Warning'
                    text='dark'
                    style={{ marginBottom: '2%' }}
                >
                    <Card.Body style={{ backgroundColor: '#FFEFDD' }}>
                        <div className='row'>
                            {
                                size.width < 500 ?
                                    ''
                                    :
                                    <div className='col-lg-1 col-12'>
                                        <br></br>
                                        <IconInfoCircleFilled
                                            width="85px" height="85px"
                                            className='text-warning'
                                        />
                                    </div>
                            }

                            <div className='col-lg-1 col-12'></div>
                            <div className='col-lg-10 col-12'>
                                <Card.Title style={{ fontWeight: '600', fontSize: size.width < 500 ? '12px' : '14px' }} className='text-warning'>Cara Upload Guarantee Letter</Card.Title>
                                <Card.Text style={{ fontSize: size.width < 500 ? '12px' : '14px' }}>
                                    <p style={{ marginBottom: '0' }}>1. Silahkan Download Template Guarantee Letter disini (<b onClick={() => handleShowGl()}>Download Template</b>)</p>
                                    <p style={{ marginBottom: '0' }}>2. Lengkapi form yang ada pada dokumen</p>
                                    <p style={{ marginBottom: '0' }}>3. Kemudian Upload Guarantee Letter anda disini!</p>
                                </Card.Text>
                            </div>
                        </div>

                    </Card.Body>
                </Card>

                <label htmlFor='uploadGl' className="form-label mb-3">Upload Guarantee Letter</label>
                <Card style={{ backgroundColor: '#B6DAF4', padding: '2%' }}>
                    <Dropzone onDrop={handleDrop}>
                        {({ getRootProps, getInputProps }) => (
                            <section type='button'>
                                <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <div className='row'>
                                        <div className='col-lg-2 col-12'>
                                            <IconFileUpload
                                                width="65px" height="65px"
                                                className='text-primary'
                                            />
                                        </div>
                                        <div className='col-lg-10 col-12'>
                                            <p style={{ fontSize: size.width < 500 ? '12px' : '16px', fontWeight: '600', marginBottom: '1%' }}>Drop file disini atau klik untuk upload file</p>
                                            <p style={{ fontSize: size.width < 500 ? '12px' : '16px', color: '#5E6278' }}>Upload 1 file</p>

                                            {
                                                newGL ?
                                                    <div className='mb-3' style={{ fontStyle: 'italic', fontWeight: '500' }}>{newGL && `${newGL.name} - ${newGL.type}`}</div>
                                                    :
                                                    ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </section>
                        )}
                    </Dropzone>
                </Card>
                <p style={{ marginTop: '2%' }}>Format File .PDF</p>
            </div>
            <div className='col-12' style={{ textAlign: 'right' }}>
                {
                    props.items.glLink ?
                        <button
                            onClick={(e) => handleDownloadGl(props.items.glFile)}
                            className='btn btn-danger'
                        >
                            Download Existing GL
                        </button>
                        :
                        ''
                }

                &nbsp;
                <button
                    disabled={disabled}
                    onClick={handleUpdate}
                    className='btn'
                    style={{ backgroundColor: '#26D07C', color: '#F2F2F2' }}
                >
                    {
                        disabled === true ?
                            'Mohon tunggu...'
                            :
                            'Upload File'
                    }
                </button>
            </div>
        </div>
    )
}

export default RiwayatTransaksiFormGLComp
